import FocusableBackButton from '@components/FocusableBackButton';
import { usePaymentRegistrationContext } from '@context/Payment/PaymentRegistration';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { useEffect } from 'react';

import { PAYMENT_REGISTRATION_VIEW } from '../focuskey';
import Content from './components/Content';

import * as styles from './styles';

const PaymentRegistrationView = () => {
  const { setButtonFocus } = usePaymentRegistrationContext();
  const { ref } = useFocusable({ focusKey: PAYMENT_REGISTRATION_VIEW });

  useEffect(() => {
    setButtonFocus();
  }, [setButtonFocus]);

  return (
    <FocusContext.Provider value={PAYMENT_REGISTRATION_VIEW}>
      <div ref={ref} css={styles.container}>
        <div css={styles.contentContainer}>
          <FocusableBackButton />
          <Content />
        </div>
      </div>
    </FocusContext.Provider>
  );
};

export default PaymentRegistrationView;
